import {ReactElement} from 'react';
import {Outlet} from 'react-router';
import './AuthLayout.scss';

export default function AuthLayout(): ReactElement {
	return (
		<div className="auth-content">
			<Outlet />
		</div>
	);
}
